import React, {
useEffect,
useState
} from "react";

import {
Routes,
Route,
Navigate
} from "react-router-dom";

import {
onAuthStateChanged
} from "firebase/auth";

import {
auth
} from "../firebase";

import GalleryApply
from "./GalleryApply";

import GalleryPending
from "./GalleryPending";

import GalleryDashboard
from "./GalleryDashboard";



import GalleryItem
from "./GalleryItem";

import GalleryPartnerOpportunity
from "./GalleryPartnerOpportunity";

const API_BASE =
"https://sellerproxy-898712575285.us-central1.run.app";

export default function PGallery() {

const [user, setUser] =
useState(null);


const [
galleryState,
setGalleryState
] = useState("checking");

useEffect(() => {


let mounted = true;

const unsubscribe =
  onAuthStateChanged(
    auth,
    async (u) => {

      try {

        if (!mounted) {
          return;
        }

       if (!u) {

  setUser(null);

  setGalleryState(
    "not-logged"
  );

  return;

}

        setUser(u);

        const token =
          await u.getIdToken(true);

        /* ==========================
           GALLERY STATUS
        ========================== */

        const response =
          await fetch(
            `${API_BASE}/api/gallery/status/${u.uid}`,
            {
              headers: {
                "X-Firebase-Authorization":
                  `Bearer ${token}`
              }
            }
          );

        const data =
          await response.json();

       


		

        console.log(
          "Gallery Status:",
          response.status,
          data
        );

        if (!mounted) {
          return;
        }

        if (
          !response.ok
        ) {

          setGalleryState(
            "apply"
          );

          return;
        }

        switch (
          data?.status
        ) {

          case "approved":
          case "active":

            setGalleryState(
              "approved"
            );

            break;

          case "pending":

            setGalleryState(
              "pending"
            );

            break;

          case "rejected":

            setGalleryState(
              "apply"
            );

            break;

          case "not-found":

            setGalleryState(
              "apply"
            );

            break;

          default:

            setGalleryState(
              "apply"
            );

        }

      } catch (error) {

  console.error(
    "Gallery Status Error:",
    error
  );

  if (mounted) {

    setGalleryState(
      "apply"
    );

  }

}
	  
	  

    }
  );

return () => {

  mounted = false;

  unsubscribe();

};


}, []);

if (
galleryState ===
"checking"
) {


return (

  <div
    style={{
      padding: 40,
      textAlign:
        "center"
    }}
  >
    Checking Access...
  </div>

);


}

return (


<Routes>

  <Route
    index
    element={
      galleryState ===
      "not-logged"
        ? (
            <GalleryPartnerOpportunity />
          )
        : galleryState ===
          "apply"
        ? (
            <Navigate
              to="/gallery/apply"
              replace
            />
          )
        : galleryState ===
          "pending"
        ? (
            <Navigate
              to="/gallery/pending"
              replace
            />
          )
        : (
            <Navigate
              to="/gallery/dashboard"
              replace
            />
          )
    }
  />

  <Route
    path="apply"
    element={
      user
        ? (
            <GalleryApply
              user={user}
            />
          )
        : (
            <Navigate
              to="/gallery"
              replace
            />
          )
    }
  />

  <Route
    path="pending"
    element={
      user
        ? (
            <GalleryPending
              user={user}
            />
          )
        : (
            <Navigate
              to="/gallery"
              replace
            />
          )
    }
  />

  <Route
    path="dashboard/*"
    element={
      galleryState ===
      "approved"
        ? (
            <GalleryDashboard
              user={user}
              
            />
          )
        : (
            <Navigate
              to="/gallery"
              replace
            />
          )
    }
  />

  <Route
    path="item/:id"
    element={
      <GalleryItem />
    }
  />

  

  <Route
    path="*"
    element={
      <Navigate
        to="/gallery"
        replace
      />
    }
  />

</Routes>


);

}
